/**
 * New feature flags should be in camelCase and follow a boolean naming rule with no prefix and "enabled" (or similar) suffix. {@link https://github.com/MewsSystems/tech-documents/blob/master/rfcs/0032-feature-flag-unification.md#1-flag-key-naming RFC 0032: Feature Flag unification}
 * @example
 * newComponentEnabled
 */
export enum DistributorFeatureFlag {
    asyncSetAdultCountEnabled = 'asyncSetAdultCountEnabled',
    bookingEngineCoralogixLoggingEnabled = 'bookingEngineCoralogixLoggingEnabled',
    bookingEngineGraphqlLoggingEnabled = 'bookingEngineGraphqlLoggingEnabled',
    bookingEngineObservabilityEnabled = 'bookingEngineObservabilityEnabled',
    bookingEngineObservabilityFullSamplingEnabled = 'bookingEngineObservabilityFullSamplingEnabled',
    bookingEngineStandaloneRecaptchaVerificationEnabled = 'bookingEngineStandaloneRecaptchaVerificationEnabled',
    bookingEngineUpsellEnabled = 'bookingEngineUpsellEnabled',
    bookingEngineWidgetRecaptchaVerificationEnabled = 'bookingEngineWidgetRecaptchaVerificationEnabled',
    calendarScreenDateInputsEnabled = 'calendarScreenDateInputsEnabled',
    confirmationScreensBookingEngineRedesignEnabled = 'confirmationScreensBookingEngineRedesignEnabled',
    currencySearchEnabledAbTest = 'currencySearchEnabledAbTest',
    enablePhoneInputPrototype = 'enablePhoneInputPrototype',
    enableReadProductClassification = 'enableReadProductClassification',
    enhancedCategoryStepEnabled = 'enhancedCategoryStepEnabled',
    pciProxyMaintenanceDisabledPaymentsEnabled = 'pciProxyMaintenanceDisabledPaymentsEnabled',
    restrictionsInHourlyPromotedServiceEnabled = 'restrictionsInHourlyPromotedServiceEnabled',
    userCurrencyDetectionEnabled = 'userCurrencyDetectionEnabled',
}
